import './components/common/accordion';
import { initYoutubeVideos } from './components/common/youtube';
import './components/features';
import './components/home/hero-section';
import './components/splide/media-about';
import './pages/b2b';
import './pages/b2b-logistics';
import './pages/newsroom';
import './pages/senior';
import './pages/senior-travel';
import './pages/teachers-landing';
import './pages/senior-research';
import './components/common/features-swiper';
import './components/freshdesk-form';
import './pages/appstoresredirect';
import './components/products-swiper';
import './pages/career';
import './pages/about';

initYoutubeVideos();
